import styled from 'styled-components';

export const Container = styled.div`
  .container {
    max-width: 1446px;
  }
  h2 {
    color: #4c4c4c;

    font-family: 'Source Sans Pro';
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 0px;
  }

  h3 {
    color: #4c4c4c;

    font-family: 'Source Sans Pro';
    font-size: 26px;
    font-weight: 600;
    margin-bottom: 0;
  }
  hr {
    background-color: #f5f3ed;
    height: 2px;
    opacity: 1;
    margin: 34px 0px;
  }

  p {
    color: #000;

    font-family: 'Libre Baskerville';
    font-size: 72px;
    font-weight: 700;
    margin-bottom: 0px;
  }
  .container {
    background-color: #fff;
    border-radius: 34px 34px 0 0;
    margin-top: 80px;
  }

  .header-table {
    border-radius: 18px;
    background: linear-gradient(180deg, #f5f3ed 0%, #f5f3ed 100%);
    padding: 19px;
  }

  .row-md-table {
    border-radius: 18px;
    border: 2px solid #e0d9ca;
    padding: 4px;
  }

  .padding {
    padding: 14px 0px;
  }

  .loan-amount {
    margin-left: calc(50% - 91px);
  }

  @media screen and (min-width: 992px) {
    p {
      font-size: 48px;
    }

    h3 {
      font-size: 20px;
    }

    .row-lg-table {
      border-radius: 18px;
      border: 2px solid #e0d9ca;
      padding: 3px;
    }

    .row-md-table {
      border-radius: 18px;
      border: none;
      padding: 0 12px;
    }

    .padding {
      padding: 0px;
    }

    .loan-amount {
      margin-left: 0;
    }
  }
`;
